module.exports = __webpack_public_path__ + "img/cashFlowBg_dbace.png";